<nav class="navbar navbar-expand-md sticky-top bg-faded custom-nav">
    <!-- <a class="custom-navbar-brand" href="#">
        <img src="./assets/images/logos/logo_bankei.png" class="custom-navbar-logo" />
    </a> -->
    <button class="navbar-toggler navbar-toggler-right collapsed" type="button" (click)="isNavbarCollapsed = !isNavbarCollapsed" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"
        aria-colapse="fals">
        <div class="nav-menu-container" [ngClass]="!isNavbarCollapsed ? 'nav-menu-change' : ''">
            <div class="nav-menu-bar1"></div>
            <div class="nav-menu-bar2"></div>
            <div class="nav-menu-bar3"></div>
        </div>
    </button>
    <!-- Navbar -->
    <div [ngbCollapse]="isNavbarCollapsed" class="navbar-collapse collapse" id="navbarSupportedContent">
        <div class="navbar-nav ml-2 mr-auto">
            <div class="custom-navbar-item mr-2">
                <a class="nav-link px-1 custom-navbar-link" (click)="navigateToHome()">
                    <img class="" src="./assets/icons/menu/home.svg"> 
                    <!-- Início -->
                    <span class="sr-only">(current)</span>
                </a>
            </div>

            <li ngbDropdown class="nav-item mr-1" custom-nav-dropdown *ngIf="accessProduto && ShowMenu(customizacaoMenuEnum.produto)">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle>
                    <img class="mr-1" src="./assets/icons/menu/beneficios.svg"> Produtos
                </a>
                <div ngbDropdownMenu>
                    <a class="navblock-item-container clickable" (click)="navigateToNovoBeneficio()" ngbDropdownToggle *ngIf="
                            ShowSubmenu(
                                customizacaoSubmenuEnum.contratarNovoBeneficio
                            )
                        ">
                        <img src="./assets/icons/menu/adicionar_beneficio.svg" class=" mr-2" /> Produtos Disponíveis
                    </a>
                    <a class="navblock-item-container clickable" (click)="navigateToContrato()" ngbDropdownToggle *ngIf="
                            ShowSubmenu(
                                customizacaoSubmenuEnum.produtosAderidos
                            )
                        ">
                        <img src="./assets/icons/menu/view.svg" class="mr-2" /> Produtos Aderidos
                    </a>
                    <a *ngIf="exibirMenusGrupo" class="navblock-item-container clickable" (click)="navigateToNovoGrupo()" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/criar_grupos.svg"> Criar Grupo
                    </a>
                    <a *ngIf="exibirMenusGrupo" class="navblock-item-container clickable" (click)="navigateToGruposList()" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/visualizar_grupos.svg"> Visualizar Grupos
                    </a>
                    <!--   <a class="navblock-item-container clickable" *ngIf="
                            ShowSubmenu(
                                customizacaoSubmenuEnum.reajusteBeneficio
                            )
                        ">
                        <img src="./assets/icons/produtos/reajustarBeneficio_produtos.png"
                            class="navblock-item-icon mr-2" />
                        Reajustar incentivos (em lote)
                    </a>
                    <a class="navblock-item-container clickable" *ngIf="
                            ShowSubmenu(
                                customizacaoSubmenuEnum.consultarBeneficio
                            )
                        ">
                        <img src="./assets/icons/produtos/consultarBeneficios_produtos.png"
                            class="navblock-item-icon mr-2" />
                        Consultar incentivos
                    </a> -->
                </div>
            </li>

            <li ngbDropdown class="nav-item mr-1 custom-nav-dropdown" *ngIf="
                    accessCadastro && ShowMenu(customizacaoMenuEnum.cadastro)
                ">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle>
                    <img class="mr-1" src="./assets/icons/menu/cadastro.svg"> Cadastro
                    <!--  <span [ngClass]="
                            isCadastroCollapsed
                                ? 'nav-triangle-down'
                                : 'nav-triangle-up'
                        "> </span> -->
                </a>
                <div ngbDropdownMenu>
                    <a class="navblock-item-container clickable" (click)="navigateToCentroCusto()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.centroCusto)">
                        <img class="mr-2" src="./assets/icons/menu/centro_custo.svg"> Centros de custo
                    </a>
                    <a class="navblock-item-container clickable" (click)="navigateToUnidade()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.unidades)">
                        <img class="mr-2" src="./assets/icons/menu/unidades.svg"> Unidades
                    </a>
                    <a class="navblock-item-container clickable" (click)="navigateToDepartamento()" ngbDropdownToggle *ngIf="
                            ShowSubmenu(customizacaoSubmenuEnum.departamentos)
                        ">
                        <img class="mr-2" src="./assets/icons/menu/departamentos.svg"> Departamentos
                    </a>
                    <a class="navblock-item-container clickable" (click)="navigateToColaborador()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.colaborador)">
                        <img class="mr-2" src="./assets/icons/menu/beneficiarios.svg"> Favorecidos
                    </a>
                    <!-- <a class="navblock-item-container clickable" (click)="navigateToVeiculos()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.colaborador) && temContaSeuValeLog">
                        <img class="mr-1" src="./assets/icons/menu/truck.svg">
                        Veículos
                    </a> -->
                    <!-- <a class="navblock-item-container clickable" (click)="navigateToCondutor()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.colaborador) && temContaSeuValeLog">
                        <img class="mr-1" src="./assets/icons/menu/beneficiarios.svg"> Condutores
                    </a> -->

                </div>
            </li>

            <li ngbDropdown class="nav-item mr-1" custom-nav-dropdown *ngIf="accessPedido && ShowMenu(customizacaoMenuEnum.pedido)">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle>
                    <img class="mr-1" src="./assets/icons/menu/pedidos.svg"> Recarga
                </a>
                <div ngbDropdownMenu>
                    <!--<a class="navblock-item-container clickable" (click)="navigateToMeusPedidos()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.meusPedidos)">
                        <img src="./assets/icons/menu/meus_pedidos.svg" class="mr-2" /> Meus pedidos
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToNovoPedido()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.novoPedido)">
                        <img src="./assets/icons/menu/novo_pedido.svg" class="mr-2" /> Novo pedido
                    </a>-->

                    <a class="navblock-item-container clickable" (click)="navigateToMinhasRecargas()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.minhasRecargas)">
                        <img src="./assets/icons/menu/meus_pedidos.svg" class="mr-2" /> Minhas recargas
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToNovarecarga()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.novaRecarga)">
                        <img src="./assets/icons/menu/novo_pedido.svg" class="mr-2" /> Nova Recarga
                    </a>
                </div>
            </li>

            <li ngbDropdown class="nav-item mr-1" custom-nav-dropdown *ngIf="accessFinanceiro  && ShowMenu(customizacaoMenuEnum.financeiro)">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle>
                    <img class="mr-1" src="./assets/icons/menu/financeiro.svg"> Financeiro
                </a>
                <div ngbDropdownMenu>
                    <!-- <a class="navblock-item-container clickable" (click)="navigateToPagamentos()" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/pagamentos.svg"> Pagamentos
                    </a> -->
                    <!-- <a class="navblock-item-container clickable" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/conta_digital.svg">
                        Conta Digital
                    </a>
                    <a class="navblock-item-container clickable" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/informe_pagamentos.svg">
                        Informe de Pagamentos
                    </a> -->
                    <!-- <a class="navblock-item-container clickable" (click)="navigateToCardsStatus()" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/credit-card.svg"> Status de cartões
                    </a> -->
                    <a class="navblock-item-container clickable" ngbDropdownToggle (click)="navigateToGestaoBeneficio()">
                        <img class="mr-2" src="./assets/icons/menu/gestao_beneficios.svg"> Gestão de créditos
                    </a>
                    <!--<a class="navblock-item-container clickable" ngbDropdownToggle (click)="navigateToExtratoRecargas()">
                        <img class="mr-2" src="./assets/icons/menu/extrato_pedidos.svg"> Extrato de recargas
                    </a>-->
                    <a class="navblock-item-container clickable" ngbDropdownToggle (click)="navigateToExtrato()">
                        <img class="mr-2" src="./assets/icons/menu/extrato_pedidos.svg"> Extrato
                    </a>
                    <!-- <a class="navblock-item-container clickable" ngbDropdownToggle *ngIf="temContaSeuValeLog" (click)="navigateToExtratoLog()">
                        <img class="mr-2" src="./assets/icons/menu/extrato_pedidos.svg"> Extrato Log
                    </a> -->
                    <!-- <a class="navblock-item-container clickable" ngbDropdownToggle (click)="navigateToDepositos()">
                        <img class="mr-2" src="./assets/icons/menu/depositar.svg"> Depósitos
                    </a> -->
                    <a class="navblock-item-container clickable" ngbDropdownToggle (click)="navigateToDepositosPagamentos()">
                        <img class="mr-2" src="./assets/icons/menu/depositar.svg"> Aportes e Pagamentos
                    </a>
                    <a class="navblock-item-container clickable" ngbDropdownToggle *ngIf="temContaSeuValeLog || temContaDespesas" (click)="navigateToSaldosAlocados()">
                        <img class="mr-2" src="./assets/icons/menu/depositar.svg"> Limites Alocados
                    </a>
                </div>
            </li>

            <!-- <li ngbDropdown class="nav-item mr-1" custom-nav-dropdown *ngIf="accessCartaoFisico">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle>
                    <img class="mr-1" src="./assets/icons/menu/creditCard.svg"> Cartões
                </a>
                <div ngbDropdownMenu>
                    <a class="navblock-item-container clickable" (click)="navigateToCartoesFisicos()" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/meus_pedidos.svg">Meus Pedidos
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToPedidoCartoesFisicos()" ngbDropdownToggle>
                        <img class="mr-2" src="./assets/icons/menu/novo_pedido.svg"> Pedir Cartões
                    </a>
                </div>
            </li> -->

            <li ngbDropdown class="nav-item mr-1" custom-nav-dropdown *ngIf="
                    accessAdministrativo &&
                    ShowMenu(customizacaoMenuEnum.administrativo)
                ">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle>
                    <img class="mr-1" src="./assets/icons/menu/administrativo.svg"> {{ menuAdministrativoLabel }}
                    <!-- <span [ngClass]="isPedidoCollapsed? 'nav-triangle-down': 'nav-triangle-up'"></span> -->
                </a>
                <div ngbDropdownMenu>
                    <a class="navblock-item-container clickable" (click)="navigateToGestor()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/gestores.svg"> {{ submenuGestoresLabel }}
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToGestorConvites()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/convites.svg"> Convites realizados
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToDadoBancario()" ngbDropdownToggle *ngIf="
                            ShowSubmenu(customizacaoSubmenuEnum.dadosBancarios)
                        ">
                        <img class="mr-2" src="./assets/icons/menu/dados_bancarios.svg"> Dados bancários
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToDadoEmpresa()" ngbDropdownToggle *ngIf="
                            ShowSubmenu(customizacaoSubmenuEnum.dadosEmpresa)
                        ">
                        <img class="mr-2" src="./assets/icons/menu/dados_empresa.svg"> Dados da empresa
                    </a>
                </div>
            </li>

            <li ngbDropdown class="nav-item mr-1" custom-nav-dropdown *ngIf="accessRelatorio">
                <a href (click)="(false)" class="nav-link px-1 px-1" ngbDropdownToggle>
                    <img class="mr-1" src="./assets/icons/menu/relatorio.svg"> Relatórios
                    <!-- <span [ngClass]="isPedidoCollapsed? 'nav-triangle-down': 'nav-triangle-up'"></span> -->
                </a>
                <div ngbDropdownMenu>
                    <a class="navblock-item-container clickable" (click)="navigateToRelatorioFavorecidoDetalhado()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/gestores.svg"> Favorecidos (Utilização detalhada)
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToRelatorioFavorecidoConsolidada()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/gestores.svg"> Favorecidos (Utilização consolidada)
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToRelatorioSaldoDetalhado()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/centro_custo.svg"> Saldo detalhado
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToRelatorioSaldoConsolidado()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/centro_custo.svg"> Saldo consolidado
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToRelatorioExtrato()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/extrato_pedidos.svg"> Relatório de extrato
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToRelatorioCredito()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/depositar.svg"> Histórico de créditos
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToRelatorioRecargas()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/depositar.svg"> Histórico de recargas
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToSituacaoCadastro()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/beneficiarios.svg"> Situação de cadastros
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToSituacaoCartao()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/beneficiarios.svg"> Situação dos cartões
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToSolicitacaoCartao()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/beneficiarios.svg"> Solicitações de cartões
                    </a>
                </div>
            </li>

            <li ngbDropdown class="nav-item mr-1"  routerLinkActive="active" custom-nav-dropdown *ngIf="temContaDespesas">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle> 
                    <img class="mr-1" src="./assets/icons/menu/relatorio.svg">
                    Despesas
                    <!-- <span [ngClass]="isPedidoCollapsed? 'nav-triangle-down': 'nav-triangle-up'"></span> -->
                </a>
                <div ngbDropdownMenu>

                    <a class="navblock-item-container clickable" (click)="navigateToTransacoesSaldoAlocado()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/centro_custo.svg"> Transações de Despesas
                    </a>

                    <a class="navblock-item-container clickable" (click)="navigateToCreditoSaldoAlocado()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.gestores)">
                        <img class="mr-2" src="./assets/icons/menu/depositar.svg"> Créditos de Despesas
                    </a>
                </div>
            </li>

            <li ngbDropdown class="nav-item mr-1"  routerLinkActive="active" custom-nav-dropdown *ngIf="temContaSeuValeLog">
                <a href (click)="(false)" class="nav-link px-1" ngbDropdownToggle> 
                    <img class="mr-1" src="./assets/icons/menu/relatorio.svg">
                    Bankei Log
                    <!-- <span [ngClass]="isPedidoCollapsed? 'nav-triangle-down': 'nav-triangle-up'"></span> -->
                </a>
                <div ngbDropdownMenu>
                    <a class="navblock-item-container clickable" (click)="navigateToVeiculos()" ngbDropdownToggle *ngIf="ShowSubmenu(customizacaoSubmenuEnum.colaborador) && temContaSeuValeLog">
                        <img class="mr-1" src="./assets/icons/menu/truck.svg">
                        Veículos
                    </a>
                    <a class="navblock-item-container clickable" ngbDropdownToggle *ngIf="temContaSeuValeLog" (click)="navigateToExtratoLog()">
                        <img class="mr-1" src="./assets/icons/menu/extrato_pedidos.svg"> Extrato Log
                    </a>
                    <a class="navblock-item-container clickable" ngbDropdownToggle *ngIf="temContaSeuValeLog" (click)="navigateToConsumo()">
                        <img class="mr-1" src="./assets/icons/menu/extrato_pedidos.svg"> Relatórios de consumo
                    </a>
                    <a class="navblock-item-container clickable" ngbDropdownToggle *ngIf="temContaSeuValeLog" (click)="navigateToValidadeCnh()">
                        <img class="mr-1" src="./assets/icons/menu/extrato_pedidos.svg"> Vencimento de CNHs
                    </a>
                </div>
            </li>

        </div>

        <div class="navbar-nav">
            <!-- <li *ngIf="exibirSaldo" ngbDropdown class="nav-item space-between mr-3 mb-1" custom-nav-dropdown>
                <a href (click)="(false)" class="nav-link dropdown-notificacao space-between" ngbDropdownToggle>
                    <img class="m-auto" src="./assets/icons/menu/carteira.svg">
                </a>
                <div ngbDropdownMenu class="notify dropdown-menu-right">
                    <ng-container  *ngFor="let teste of testes">
                        <div class="d-flex text-muted p-1 align-items-center ">
                            <div class="span-container mr-2">
                                <img class="bd-placeholder-img flex-shrink-0 me-2 rounded" src="./assets/icons/menu/carteira.svg">
                            </div>

                            <p class="small lh-sm m-0">
                                <strong class="d-block text-gray-dark notify-text">Resgate de R$100,00 realizado do favorecido João da Silva foi efetuado.</strong>
                                Clique aqui para ver mais detalhes
                            </p>
                        </div>
                    </ng-container>
                    <p class="small lh-sm m-2 text-center">
                        <strong class="d-block text-gray-dark">Ver todas notificações</strong>
                    </p>
                </div>
            </li> -->
            <li *ngIf="showAvailableBalance" ngbDropdown class="nav-item space-between mr-2 3 mb-1" custom-nav-dropdown>
                <a href (click)="(false)" class="nav-link dropdown-notificacao space-between" ngbDropdownToggle>
                    <img class="m-auto" src="./assets/icons/menu/sino.svg">
                </a>
                <!-- <div *ngIf="unreadNotifications > 0" class="icon-badge"></div> -->
                <div ngbDropdownMenu class="notify dropdown-menu-right">
                    <ul class="list-unstyled m-0">
                        <ng-container  *ngFor="let item of notificacoes">
                            <li class="media m-3">
                                <div class="span-container mr-2">
                                    <img class="bd-placeholder-img flex-shrink-0 me-2 rounded" [src]="'./assets/icons/notificacao/'+ item.type +'.svg'">
                                </div>
                                <div class="media-body">
                                    <p class="small lh-sm m-0" >
                                        <!-- Lucas Oliveira -->
                                        <strong class="d-block text-gray-dark">{{ item.description}}</strong>
                                        <!-- <span class="notify-text">{{ item.description}}</span> -->
                                        {{ item.createdAt | date: "dd/MM/yyyy" }}
                                    </p>
                                </div>
                                <!-- <div *ngIf="item.unread" class="d-flex justify-content-end">
                                    <div class="readed"></div>
                                </div> -->
                            </li>
                            <div class="dropdown-divider m-0"></div>
                        </ng-container>
                      </ul>
                      <div class="dropdown-divider m-0"></div>
                    <p class="small lh-sm p-2 m-0 text-center to-notification" ngbDropdownToggle (click)="navigateToNotificaoList()">
                        <strong class="d-block text-gray-dark">Ver todas notificações</strong>
                    </p>
                </div>
            </li>
            <li *ngIf="showAvailableBalance" ngbDropdown class="nav-item space-between mr-2 3 mb-1" custom-nav-dropdown>
                <a (click)="(getBalances())" class="nav-link dropdown-empresa space-between" ngbDropdownToggle>
                    <img class="m-auto" src="./assets/icons/menu/carteira.svg">
                    <span class="ml-3 my-auto">{{(currentAccountBalance > 0) ? (currentAccountBalance | currency ) : "R$ 0,00"}}</span>
                    <img class="ml-3 my-auto" src="./assets/icons/menu/seta.svg">
                </a>
                <div ngbDropdownMenu style="min-width:12rem">
                    <div style="padding: 10px 10px 0px 10px" *ngIf="isCurrentAccountBalanceLoading">
                        <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '25px', 'margin-bottom': 0 }" animation="progress-dark"></ngx-skeleton-loader>
                    </div>
                    <div style="padding: 0px 10px 5px 10px" *ngIf="isAllocatedBalancesLoading">
                        <ngx-skeleton-loader count="2" [theme]="{ 'border-radius': '5px', height: '25px', 'margin-bottom': 0 }" animation="progress-dark"></ngx-skeleton-loader>
                    </div>
                    <ng-container *ngIf="!isCurrentAccountBalanceLoading">
                        <div class="navblock-item-container" >
                            <span><b>Conta Corrente</b></span>
                            <br>
                            <span>{{(currentAccountBalance > 0) ? (currentAccountBalance | currency ) : "R$ 0,00"}}</span>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!isAllocatedBalancesLoading">
                        <div *ngFor="let allocatedBalance of allocatedBalances"  class="navblock-item-container" >
                            <span><b>{{ allocatedBalance.name }}</b></span>
                            <br>
                            <span>{{(allocatedBalance.balance > 0) ? (allocatedBalance.balance | currency ) : "R$ 0,00"}}</span>
                        </div>
                    </ng-container>
                    <!-- <a *ngIf="trocarCedente" class="navblock-item-container clickable" (click)="ChangeAssignor()">
                        Trocar de empresa
                    </a>
                    <a class="navblock-item-container clickable" (click)="ChangePassword()">
                        Redefinir senha
                    </a>
                    <a class="navblock-item-container clickable" (click)="logout()">
                        Sair
                    </a> -->
                </div>
                <!-- <a href (click)="(false)" class="nav-link dropdown-empresa space-between">
                    <img class="m-auto" src="./assets/icons/menu/carteira.svg">
                    <span class="ml-3 my-auto">{{(saldoDisponivel > 0) ? (saldoDisponivel | currency ) : "R$ 0,00"}}</span>
                </a> -->
            </li>

            <li ngbDropdown class="nav-item space-between mb-1" custom-nav-dropdown>
                <a href (click)="(false)" class="nav-link dropdown-empresa space-between" ngbDropdownToggle>
                    <span class="mr-3 my-auto text-truncate" style="max-width: 130px;">{{ nomeEmpresa }}</span>
                    <img class="m-auto" src="./assets/icons/menu/seta.svg">
                </a>
                <div ngbDropdownMenu>
                    <a *ngIf="trocarCedente" class="navblock-item-container clickable" (click)="ChangeAssignor()">
                        Trocar de empresa
                    </a>
                    <a class="navblock-item-container clickable" (click)="ChangePassword()">
                        Redefinir senha
                    </a>
                    <a class="navblock-item-container clickable" (click)="logout()">
                        Sair
                    </a>
                </div>
            </li>
        </div>


        <!-- <div class="text-warning mx-2">{{ nomeEmpresa }}</div>


        <div class="text-warning mx-2" *ngIf="exibirSaldo">
            {{(saldoDisponivel > 0) ? (saldoDisponivel | currency:'BRL':true) : "R$ 0,00"}}
        </div>

        <div class="text-warning mx-2" *ngIf="exibirSaldo && saldoDisponivel == 0">
            R$ 0,00
        </div>

        <div class="custom-navbar-item custom-navbar-item-text-position">
            <a class="nav-link custom-navbar-link" (click)="logout()">Sair</a>
        </div> -->
    </div>
</nav>

<app-new-alert></app-new-alert>

<router-outlet></router-outlet>

<!--Modal de Aviso de aceite termo-->
<ng-template #noContrato let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Para fazer um pedido, você deve ter ao menos um produto(incentivo) ativo.
                </p>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button-text" type="button" (click)="
                        navigateToNovoBeneficio(); modal.dismiss('Close click')
                    ">
                    Clique aqui para ser redirecionado a tela de novo incentivo
                </button>
            </div>
        </div>
    </div>
</ng-template>
<!-- Fim Modal -->

<!--Modal Colaborador não encontrado-->
<ng-template #noColaborador let-modal>
    <div class="container custom-modal">
        <div class="row mx-5">
            <div class="col-12 custom-modal-title my-5 text-center">
                <p>
                    Para fazer um pedido, você deve ter ao menos um favorecido cadastrado para recebimento de um produto(incentivo).
                </p>
            </div>
            <div class="col-12 text-center my-2">
                <button class="custom-modal-button-text" type="button" (click)="
                        navigateToColaborador(); modal.dismiss('Close click')
                    ">
                    Clique aqui para ser redirecionado a tela de favorecido
                </button>
            </div>
        </div>
    </div>
</ng-template>
<!-- Fim Modal -->
